import {deepCopy} from '../utils/objects';
import {TOGGLE_DISCOVER_VITRINE_BOX, TOGGLE_DISCOVER_BDR_BOX} from '../actions/constant';

const initialState = {};

const toggleBox = (current = true) => !current;

export default function display(state = initialState, action = {}) {
  const {type, payload} = action;
  if (type === TOGGLE_DISCOVER_VITRINE_BOX) {
    const {organisationId} = payload;
    return {
      ...deepCopy(state),
      [organisationId]: {
        ...state[organisationId],
        showDiscoverVitrineBox: toggleBox(state[organisationId]?.showDiscoverVitrineBox)
      }
    };
  }

  if (type === TOGGLE_DISCOVER_BDR_BOX) {
    const {organisationId} = payload;
    return {
      ...deepCopy(state),
      [organisationId]: {
        ...state[organisationId],
        showDiscoverBdrBox: toggleBox(state[organisationId]?.showDiscoverBdrBox)
      }
    };
  }

  return state;
}
